// extracted by mini-css-extract-plugin
export default {"root":"summary-item_root__Q+sdH","title":"summary-item_title__LAnpz","danger":"summary-item_danger__sQ1c0","placeHolderShimmer":"summary-item_placeHolderShimmer__WYyg9"};